import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { busyIndicatorState } from '~/state/atoms/viewerAtoms';

export default function BusyIndicator() {
    const { isOpen, message } = useRecoilValue(busyIndicatorState);
    return (
        isOpen && (
            <Box
                position="absolute"
                overflow="hidden"
                top={0}
                left={0}
                zIndex={4000}
                width="100vw"
                height="100vh"
            >
                <Backdrop open={true} style={{ zIndex: 1300 }}>
                    <Box
                        p={3}
                        width={400}
                        borderRadius={2}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor={(theme) => theme.palette.background.paper}
                    >
                        <CircularProgress size={32} />
                        <Typography mt={2} textAlign="center">
                            {message}
                        </Typography>
                    </Box>
                </Backdrop>
            </Box>
        )
    );
}
